var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3815 6.93614L9.06367 4.61831M2.3999 13.5999L4.361 13.382C4.6006 13.3554 4.7204 13.3421 4.83237 13.3058C4.93172 13.2737 5.02626 13.2282 5.11343 13.1707C5.21169 13.1059 5.29692 13.0207 5.46739 12.8502L13.1199 5.19777C13.7599 4.55772 13.7599 3.51999 13.1199 2.87994C12.4798 2.23989 11.4421 2.23989 10.802 2.87994L3.14956 10.5324C2.9791 10.7029 2.89386 10.7881 2.82907 10.8864C2.77158 10.9735 2.72615 11.0681 2.69398 11.1674C2.65773 11.2794 2.64442 11.3992 2.6178 11.6388L2.3999 13.5999Z",
    stroke: "#3485FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fbf60215528664dce290ab7a871fd750.svg";
export { ForwardRef as ReactComponent };